window.addEventListener('DOMContentLoaded', ()=>{
  const $cursor = document.querySelector('#cursor');
  if (!$cursor) return;
  window.addEventListener('mousemove', (e) => {
    const posX = e.clientX;
    const posY = e.clientY;
    $cursor.style.setProperty('--pos-x', `${posX}px`);
    $cursor.style.setProperty('--pos-y', `${posY}px`);
  })

  window.addEventListener('mousemove', (e) => {
    const target = e.target;
    if (target.closest('a, button, [data-cursor="hover"]')) {
      $cursor.classList.add('--hover');
    } else {
      $cursor.classList.remove('--hover');
    }
  })
})